import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M14.19 4.751H11.5v-1.5h5.25v5.25h-1.5v-2.69l-3.22 3.22-1.06-1.06zm-10.94 6.75h1.5v2.69l3.22-3.22 1.06 1.06-3.22 3.22H8.5v1.5H3.25z"
    }, null, -1)
  ])))
}
export default { render: render }